import React from 'react';

import { FormattedHTMLMessage } from 'react-intl';

import faceExample from '@assets/images/faceExample.jpg';

import styles from './ProfilePictureNote.less';

const ProfilePictureNote = () => (
  <div>
    <FormattedHTMLMessage id="profilePictureNote.instructions" />
    <img src={faceExample} className={styles.picture} />
    <FormattedHTMLMessage id="profilePictureNote.warning" />
  </div>
);

export default ProfilePictureNote;
